import * as React from "react";
import { connect } from "react-redux";
import qs from "qs";
import PropTypes from "prop-types";
import classNames from "classnames";
import SwipeableViews from "react-swipeable-views";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Button from "@material-ui/core/Button/Button";
import Select from "@material-ui/core/Select/Select";
import Slide from "@material-ui/core/Slide/Slide";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import CloseIcon from "@material-ui/icons/Close";
import HelpIcon from "@material-ui/icons/HelpOutline";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import TableChartIcon from "@material-ui/icons/TableChartOutlined";
import LineChartIcon from "@material-ui/icons/TimelineOutlined";
import {
  dataBarChart,
  dataBarChartZero,
  dataLineChart,
  dataLineChartZero,
} from "../../components/Charts/CySampleData";
import CyPortfolioDetailsSortable from "../../components/Charts/CyPortfolioDetailsSortable";
import CyLineChart from "../../components/Charts/CyLineChart";
import DoubleArrowRight from "../../components/Icons/DoubleArrowRight";
import PercentageNumber from "../../components/UI/PercentageNumber";
import { portfolioAction } from "../../actions/portfolio.action";
import { appAction } from "../../actions/app.action";
import { CyMath } from "../../utilities/math";
import { CyNumber } from "../../utilities/number";
import {
  END_OF_CPR_YEAR,
  generateChartData, generateScenarioString,
  getRiskPeriod,
  getRiskPeriodLossTolerance,
} from "../../utilities/cpr";
import { isBasicView } from "../../utilities/access";
import CyComparison from "../../components/Charts/CyComparison";
import Calculating from "../../components/Loading/Calculating";
import CurrencyNumber from "../../components/UI/CurrencyNumber";
import SectionHeader from "../../components/UI/SectionHeader";
import RRoR from "../../components/UI/RRoR";
import EditableTextField from "../../components/Forms/EditableTextField";
import MinimumRequiredDialog from "../../components/UI/MinimumRequiredDialog";
import { isMobile } from "../../utilities/mobile";
import moment from "moment";
import PortfolioAdvisorFeeModal from "./components/PortfolioAdvisorFeeModal";
import feeAction from "../../actions/fee.action";
import HighLevelDisclosure from "../SummaryPDF/components/HighLevelDisclosure";
import CyTotalIncomeChart from "../../components/Charts/CyTotalIncomeChart";
import Parameter from "./components/Parameter";
import { getValidAdvisorFees } from "../../utilities/validators";
import { PortfolioFeeUpdateModal } from "../Cy/components";
import { CyManagerTypes } from "../../utilities/managerTypes";
import CyMonteCarlo from "../../components/Charts/CyMonteCarlo";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    paddingBottom: theme.wbiComponent.portfolioConfigBlock.height * 2 + 20,
  },
  subtitle: {
    fontWeight: 500,
    fontSize: "18px",
    [theme.breakpoints.down("md")]: {
      fontSize: 18,
    },
  },
  contentCaption: {
    marginBottom: 10,
  },
  chartSliderWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      width: "104%",
    },
    "& > div": {
      width: "100%",
    },
  },
  chartToggleGroup: {
    display: "flex",
    backgroundColor: theme.palette.secondary.main,
    padding: "2px",
    float: "right",
  },
  chartSliderControl: {
    minWidth: 38,
    borderRadius: 0,
    backgroundColor: theme.palette.primary.contrastText,
    padding: 6,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    "& svg": {
      color: theme.palette.secondary.main,
    },
    "&.active": {
      backgroundColor: theme.palette.secondary.main,
      "& svg": {
        color: `${theme.palette.primary.contrastText} !important`,
      },
    },
  },
  chartWrapper: {
    minHeight: 450,
    overflow: "hidden",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      overflowX: "auto",
    },
  },
  chartCaption: {
    marginBottom: 10,
  },
  portfolioConfig: {
    height: theme.wbiComponent.portfolioConfigBlock.height,
    position: "fixed",
    width: `calc(100% - ${
      theme.wbiComponent.ctaController.totalWidth +
      theme.wbiComponent.staticNavigation.totalWidth +
      2 * theme.wbiComponent.cyContainer.basePadding
    }px)`,
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 185px)",
      height: 120,
      right: 45,
    },
    [theme.breakpoints.down("lg")]: {
      width: "calc(100% - 210px)"
    },
    bottom: 0,
    zIndex: 1,
    right: theme.wbiComponent.ctaController.totalWidth,
    background: theme.palette.grey["A100"],
    transition: "height 0.3s ease",
    "&.opened": {
      height: theme.wbiComponent.portfolioConfigBlock.height * 2,
    },
  },
  portfolioConfigBlockInnerGridContainer: {
    height: theme.wbiComponent.portfolioConfigBlock.height,
    padding: "0 20px",
  },
  formGroup: {
    flexDirection: "row",
    "& label": {
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  },
  radioBase: {
    width: 34,
    height: 34,
    [theme.breakpoints.down("md")]: {
      height: 24,
    },
    marginLeft: 6,
    "& svg": {
      [theme.breakpoints.down("md")]: {
        fontSize: 17,
      },
    },
  },

  settingsText: {
    float: "left",
    color: theme.palette.secondary.charcoal,
    fontSize: 14,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 13,
    },
  },
  settingsTextMain: {
    fontSize: 14,
    color: theme.palette.secondary.charcoal,
    fontWeight: 500,
  },
  settingDrawerControl: {
    fontSize: 48,
    textAlign: 'center',
    [theme.breakpoints.down("md")]: {
      fontSize: 27,
      height: 120,
      width: 58,
    },
    "& p": {
      [theme.breakpoints.down("md")]: {
        fontSize: 13,
      },
    },
    width: "100%",
    height: theme.wbiComponent.portfolioConfigBlock.height,
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    background: theme.palette.grey["A100"],
  },
  checkbox: {
    width: 24,
    height: 24,
    padding: 0,
    marginRight: 10,
    float: "left",
    "& svg": {
      fontSize: 19,
    },
  },
  smallSelect: {
    fontSize: 14,
  },
  controller: {
    width: theme.wbiComponent.ctaController.totalWidth,
    [theme.breakpoints.down("md")]: {
      width: "45px",
    },
    height: "100%",
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 0,
    background: `linear-gradient(-189deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 94%)`,
    boxShadow: "inset 0 0 17px rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      height: 360,
      width: "100%",
      background: "transparent",
      // background: 'linear-gradient(-12deg, #FAA42F 45%, #FCCD8C 68%)',
      // boxShadow: '0 0 6px 0 rgba(0,0,0,0.20)',
      cursor: "pointer",
      border: "none",
    },
    "@media print": {
      // eslint-disable-line no-useless-computed-key
      display: "none",
    },
  },
  controllerDisabled: {
    background:
      "linear-gradient(-189deg, rgb(214, 214, 214) 0%, rgb(125, 125, 125) 94%)",
  },
  tooltip: {
    background: theme.palette.primary.contrastText,
    border: `1px solid ${theme.palette.secondary.lightGray}`,
    color: theme.palette.secondary.charcoal,
    boxShadow: theme.shadows[1],
    opacity: 1,
    fontSize: 14,
    [theme.breakpoints.down("md")]: {
      paddingBottom: 30,
    },
  },
  tooltipBtn: {
    padding: "0",
    marginLeft: "10px",
    minWidth: "auto",
    minHeight: "auto",
    "&:hover": {
      background: "transparent",
    },
  },
  hintIcon: {
    fontSize: 18,
  },
  saveButtonNavItem: {
    width: theme.wbiComponent.staticNavigation.totalWidth,
    left: 0,
    textTransform: "uppercase",
    color: theme.palette.grey[50],
    fontSize: 14,
    "&:disabled": {
      cursor: "not-allowed",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      marginLeft: "-12px",
    },
    "& svg": {
      [theme.breakpoints.down("md")]: {
        width: 18,
        marginLeft: 7,
      },
    },
  },
  finePrint: {
    fontSize: 12,
    textAlign: "left",
    margin: "30px 0 0",
  },
  riskCheckbox: {
    [theme.breakpoints.down("md")]: {
      marginLeft: "-5px !important",
    },
    "& h3": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "3px",
      },
    },
  },
  includeCheckbox: {
    "& h3": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "3px",
      },
    },
    "&.visually-hidden": {
      visibility: "hidden",
    },
  },
  noPortfolioWrapper: {
    paddingTop: "20%",
  },
  portfolioName: {
    color: theme.palette.grey[500],
    letterSpacing: "1px",
    fontWeight: 400,
  },
  portfolioNameEdit: {
    "& input": {
      color: theme.palette.grey[800],
      letterSpacing: "1px",
      fontSize: "36px",
      fontWeight: 500,
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    marginBottom: "2%",
  },
  paramWrapper: {
    margin: "20px 0",
  },
  paramBlock: {
    fontSize: "14px",
    marginBottom: "1%",
  },
  paramValue: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    textAlign: "left",
    paddingLeft: "3%",
  },
  paramLabel: {
    textAlign: "right",
    borderRight: `1px solid ${theme.palette.grey["A400"]}`,
    paddingRight: "3%",
  },
  dInlineBlock: {
    display: "inline-block",
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    const parsedQueryString = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.state = {
      isPhone: isMobile.phone(),
      activeStep: 0,
      rror: "",
      riskTolerance: "",
      portfolioConfigDrawerOpened: parsedQueryString.editFee,
      riskAverse:
        this.props.user.user.advisorConfig &&
        this.props.user.user.advisorConfig.riskAverse !== undefined
          ? this.props.user.user.advisorConfig.riskAverse
          : this.props.user.advisorConfig.riskAverse,
      // includeTheoretical: this.props.user.user.advisorConfig && this.props.user.user.advisorConfig.includeTheoretical !== undefined ? this.props.user.user.advisorConfig.includeTheoretical: this.props.user.advisorConfig.includeTheoretical,
      includeTheoretical: false, // force to default to false so that previously advisorConfig won't affect the value
      managerType:
        this.props.user.user.advisorConfig &&
        this.props.user.user.advisorConfig.managerType !== undefined
          ? this.props.user.user.advisorConfig.managerType
          : this.props.user.advisorConfig.managerType,
      riskPeriod:
        this.props.user.user.advisorConfig &&
        this.props.user.user.advisorConfig.riskPeriod !== undefined
          ? this.props.user.user.advisorConfig.riskPeriod
          : this.props.user.advisorConfig.riskPeriod,
      dataBarChart: dataBarChart,
      dataLineChart: dataLineChartZero,
      solveFor: "risk",
      singleStrategy: this.props.singleStrategyList['WBI Portfolios'].length
        ? this.props.singleStrategyList['WBI Portfolios'][0].strategyScenario
        : "",
      initialInvestment:
        (this.props.portfolio.currentPortfolio &&
          this.props.portfolio.currentPortfolio.metadata &&
          this.props.portfolio.currentPortfolio.metadata.initialInvestment) ||
        0,
      unsolvableOutcomeDialogOpen: false,
      minInitInvestDialogOpen: false,
      lastModifiedConfig: {},
      minInitInvestDialogInstruction: "",
      portfolioName: "",
      isEditableFieldValid: {},
      annualWithdrawal: 0,
      portfolioAdvisorFee: null,
      portfolioAdvisorFeeModalOpened: false,
      portfolioFeeUpdateModalOpened: false,
      managerTypeList: CyManagerTypes.getManagerTypes(this.props.appName, this.props.user.user.approved, this.props.accessLevel)
    };
  }

  handleToggle = (step) => () => {
    this.setState({
      activeStep: step,
    });
  };

  handleStepChange = (activeStep) => {
    this.setState({ activeStep });
  };

  handleTransitionEnd = () => {
    if (this.state.activeStep === 0) {
      this.setState({ dataBarChart: dataBarChart });
      this.setState({ dataLineChart: dataLineChartZero });
    }
    if (this.state.activeStep === 1) {
      this.setState({ dataBarChart: dataBarChartZero });
      this.setState({ dataLineChart: dataLineChart });
    }
  };

  /* 
    Update the state of a min init invest dialog 
    status / message / min amount required
  */
  openMinInitInvestDialog = (minAmount) => {
    const { CurrencyFormatter } = CyNumber;
    this.setState({
      minInitInvestDialogOpen: true,
      minInitInvestAmount: CurrencyFormatter(minAmount),
      minInitInvestDialogInstruction:
        "Please edit the investment amount to select this item.",
    });
  };

  /*
    Check the minimum invest amount
    - Over 250k required for WBI Blend manager type options
    - Over 50k required for any other portfolio config changes
  */
  checkMinimumInvest = (name, booleanValue, event) => {
    const { portfolio, strategyAccountMinimum, singleStrategyList } = this.props;
    const { rror, riskTolerance, includeTheoretical, managerType, riskPeriod, solveFor, singleStrategy } = this.state;
    const useSingleStrategy = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(name === 'managerType' ? event.target.value : managerType);
    let overrideIncludeTheoretical = false;
    if (name === 'includeTheoretical') {
      overrideIncludeTheoretical = this.calculateIncludeHypothetical(managerType, !includeTheoretical);
    } else {
      overrideIncludeTheoretical = this.calculateIncludeHypothetical(event.target.value, includeTheoretical);
    }

    const targetScenario = generateScenarioString({
      includeTheoretical: overrideIncludeTheoretical,
      riskAverse: undefined,
      managerType: name === 'managerType' ? event.target.value : managerType,
      riskPeriod: name === 'riskPeriod' ? event.target.value : riskPeriod,
      rror: name === 'rror' ? event.target.value : rror,
      riskTolerance: name === 'riskTolerance' ? event.target.value : riskTolerance,
      solveFor: name === 'solveFor' ? event.target.value : solveFor,
      singleStrategy: useSingleStrategy ?
        singleStrategyList[name === 'managerType' ? event.target.value : managerType][0].strategyScenario :
        name === 'singleStrategy' ?
          event.target.value :
          singleStrategy,
      cprScenarioStringPrefix: ''
    });

    let strategyMinimum;
    if (name === 'managerType') {
      strategyMinimum = useSingleStrategy ?
        strategyAccountMinimum["SingleStrategy"].find(c => c.Scenario === singleStrategyList[event.target.value][0].strategyScenario):
        strategyAccountMinimum["All"].find(c => c.Scenario === targetScenario);
    } else if (name === 'singleStrategy') {
      strategyMinimum = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType) ?
        strategyAccountMinimum["SingleStrategy"].find(c => c.Scenario === event.target.value) :
        strategyAccountMinimum["All"].find(c => c.Scenario === targetScenario);
    } else {
      strategyMinimum = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType) ?
        strategyAccountMinimum["SingleStrategy"].find(c => c.Scenario === singleStrategy) :
        strategyAccountMinimum["All"].find(c => c.Scenario === targetScenario);
    }

    if (strategyMinimum && portfolio.currentPortfolio.metadata) {
      if (portfolio.currentPortfolio.metadata.initialInvestment < strategyMinimum.AccountMinimum) {
        this.openMinInitInvestDialog(strategyMinimum.AccountMinimum);
      } else {
        this.handlePortfolioReconfig(name, booleanValue, event);
      }
    }
  };

  handlePortfolioReconfig = (name, booleanValue, event) => {
    const oldState = { ...this.state };
    if (booleanValue) {
      this.setState(
        {
          [name]: event.target.checked,
          lastModifiedConfig: {
            [name]: oldState[name],
          },
        },
        this.updatePortfolio
      );
    } else {
      if (name === "managerType") {
        let includeTheoretical = false;
        let riskPeriod = this.state.riskPeriod;
        let riskTolerance = this.state.riskTolerance;
        let rror = this.state.rror;
        const managerType = event.target.value;

        switch (managerType) {
          case "401k":
            riskPeriod = "mdd";
            if (["-0.25", "-0.35"].some((v) => v === riskTolerance))
              riskTolerance = "-0.05";
            if (["0.06", "0.08", "0.1", "0.12"].some((v) => v !== rror))
              rror = "0.06";
            break;
          case "WBI Portfolios":
          case "WBI Envestnet":
          case "Other Models":
            this.setState({
              portfolioConfigDrawerOpened: true,
              singleStrategy: this.props.singleStrategyList[managerType][0].strategyScenario
            });
            break;
          default:
            break;
        }
        this.setState(
          {
            [name]: event.target.value,
            includeTheoretical: this.calculateIncludeHypothetical(managerType, includeTheoretical),
            riskPeriod,
            riskTolerance,
            rror,
            lastModifiedConfig: {
              [name]: oldState[name],
            },
          },
          this.updatePortfolio
        );
      } else {
        this.setState(
          {
            [name]: event.target.value,
            lastModifiedConfig: {
              [name]: oldState[name],
            },
          },
          this.updatePortfolio
        );
      }
    }
  };

  /*
    Check the value on client investment parameters
    and return {
          status: bool,
          message: string
      }
  */
  validateEditableField = (strategyMin) => (name, value) => {
    if (value.toString().trim() === "") {
      return {
        status: false,
        message: "Please fill the field",
      };
    }

    if (name === "initialInvestment") {
      let initialInvestment = CyNumber.CurrencyParser(value);
      this.setState({ initialInvestment });
      if (strategyMin) {
        const isOverThreshold = initialInvestment >= Number(strategyMin);
        if (isOverThreshold) {
          return {
            status: isOverThreshold,
            message: "",
          };
        } else {
          return {
            status: false,
            message: `The minimum is $${Number(strategyMin)}`,
          };
        }
      }
    } else if (name === "annualWithdrawal") {
      let annualWithdrawal = CyNumber.CurrencyParser(value);
      if (annualWithdrawal < 0) {
        return {
          status: false,
          message: "The minimum is 0",
        };
      } else {
        this.setState({ annualWithdrawal });
        return {
          status: true,
          message: "",
        };
      }
    } else {
      this.setState({ [name]: value });
      return {
        status: true,
        message: "",
      };
    }
  };

  updatePortfolio = () => {
    const {
      riskAverse,
      riskPeriod,
      includeTheoretical,
      managerType,
      rror,
      riskTolerance,
      solveFor,
      initialInvestment,
      annualWithdrawal,
      singleStrategy,
    } = this.state;
    this.props.dispatch(
      portfolioAction.savePortfolioMetadata(
        this.props.currentPortfolioId,
        this.props.currentHouseholdId,
        {
          riskAverse,
          riskPeriod,
          includeTheoretical: this.calculateIncludeHypothetical(
            managerType,
            includeTheoretical
          ),
          managerType,
          cprRror: rror,
          cprRisk: riskTolerance,
          solveFor,
          initialInvestment,
          annualWithdrawal,
          singleStrategy,
        }
      )
    );
  };

  /* Dispatch savePortfolioName to update the portfolio name */
  updatePortfolioName = () => {
    const { portfolioName } = this.state;
    this.props.dispatch(
      portfolioAction.savePortfolioName(
        this.props.currentPortfolioId,
        this.props.currentHouseholdId,
        { name: portfolioName }
      )
    );
  };

  directToSummary = () => {
    const { currentPortfolioId, currentHouseholdId } = this.props;
    if (currentPortfolioId) {
      this.props.history.push(
        `/Portal/household/${currentHouseholdId}/summary/${currentPortfolioId}`
      );
    } else {
      this.props.history.push(`/Portal/household/${currentHouseholdId}/summary`);
    }
  };

  /*
     - Close the unsolvable outcome dialog
     - Update state of values on config with current portfolio data
     - Set the scenario based on the updated state
  */
  unsolvableOutcomeDialogClose = () => {
    this.setState(
      {
        unsolvableOutcomeDialogOpen: false,
        ...this.state.lastModifiedConfig,
      },
      this.updatePortfolio
    );
  };

  /* Close the minimum initial investment dialog */
  minInitInvestDialogClose = () => {
    this.setState({
      minInitInvestDialogOpen: false,
    });
  };

  calculateIncludeHypothetical = (managerType, includeTheoretical) => {
    let calculatedIncludeTheoretical = includeTheoretical;
    if (
      this.state.managerTypeList.filter(m => m.allowBackTested === false).find(m => m.code === managerType)
    ) {
      calculatedIncludeTheoretical = false;
    }
    if (managerType === "ETF Innovation") {
      calculatedIncludeTheoretical = true;
    }
    return calculatedIncludeTheoretical;
  };

  savePortfolioAdvisorFee = (portfolioAdvisorFee) => (e) => {
    this.setState(
      {
        portfolioAdvisorFee,
        portfolioAdvisorFeeModalOpened: false,
      },
      () => {
        this.props.dispatch(
          feeAction.updatePortfolioAdvisorRate(
            portfolioAdvisorFee,
            this.props.currentHouseholdId,
            this.props.currentPortfolioId
          )
        );
      }
    );
  };

  savePortfolioInvestmentAmount = (initialInvestment) => (e) => {
    this.setState(
      {
        initialInvestment,
        portfolioFeeUpdateModalOpened: false,
      },
      this.updatePortfolio
    );
  };

  componentDidMount() {
    const { portfolio, currentPortfolioId, currentHouseholdId } = this.props;
    if (currentPortfolioId || currentHouseholdId)
      this.props.dispatch(
        portfolioAction.getPortfolio(currentPortfolioId, currentHouseholdId)
      );
    if (portfolio.currentPortfolio) {
      const managerType = portfolio.currentPortfolio.metadata.managerType
        ? portfolio.currentPortfolio.metadata.managerType
        : this.props.user.user.advisorConfig &&
          this.props.user.user.advisorConfig.managerType !== undefined
        ? this.props.user.user.advisorConfig.managerType
        : this.props.user.advisorConfig.managerType;
      this.setState({
        rror: portfolio.currentPortfolio.metadata.cprRror
          ? portfolio.currentPortfolio.metadata.cprRror
          : CyMath.roundRROR(portfolio.currentPortfolio.metadata.rror),
        riskTolerance: portfolio.currentPortfolio.metadata.cprRisk
          ? portfolio.currentPortfolio.metadata.cprRisk
          : CyMath.roundLossTolerance(portfolio.currentPortfolio.metadata.risk),
        scenario: portfolio.currentPortfolio.metadata.scenario
          ? portfolio.currentPortfolio.metadata.scenario
          : "",
        riskAverse:
          portfolio.currentPortfolio.metadata.riskAverse !== undefined
            ? portfolio.currentPortfolio.metadata.riskAverse
            : this.props.user.user.advisorConfig &&
              this.props.user.user.advisorConfig.riskAverse !== undefined
            ? this.props.user.user.advisorConfig.riskAverse
            : this.props.user.advisorConfig.riskAverse,
        includeTheoretical:
          portfolio.currentPortfolio.metadata.includeTheoretical !== undefined
            ? portfolio.currentPortfolio.metadata.includeTheoretical
            : this.calculateIncludeHypothetical(
                managerType,
                portfolio.currentPortfolio.metadata.includeTheoretical
              ),
        managerType: managerType,
        riskPeriod: portfolio.currentPortfolio.metadata.riskPeriod
          ? portfolio.currentPortfolio.metadata.riskPeriod
          : this.props.user.user.advisorConfig &&
            this.props.user.user.advisorConfig.riskPeriod !== undefined
          ? this.props.user.user.advisorConfig.riskPeriod
          : this.props.user.advisorConfig.riskPeriod,
        solveFor: portfolio.currentPortfolio.metadata.solveFor
          ? portfolio.currentPortfolio.metadata.solveFor
          : "risk",
        singleStrategy:
          portfolio.currentPortfolio.metadata.singleStrategy &&
          this.props.singleStrategyList.hasOwnProperty(portfolio.currentPortfolio.metadata.managerType) &&
          this.props.singleStrategyList[portfolio.currentPortfolio.metadata.managerType].some(
            (ss) =>
              ss.strategyScenario ===
              portfolio.currentPortfolio.metadata.singleStrategy
          )
            ? portfolio.currentPortfolio.metadata.singleStrategy
            : this.props.singleStrategyList.hasOwnProperty(portfolio.currentPortfolio.metadata.managerType) &&
              this.props.singleStrategyList[portfolio.currentPortfolio.metadata.managerType].length
            ? this.props.singleStrategyList[portfolio.currentPortfolio.metadata.managerType][0].strategyScenario
            : "",
        initialInvestment:
          portfolio.currentPortfolio.metadata.initialInvestment,
        annualWithdrawal:
          portfolio.currentPortfolio.metadata.annualWithdrawal || 0,
      });
    }
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setPortfolioNav(true));
    this.props.dispatch(appAction.updateProgressStep(4));
    window.scrollTo(0, 0);

    if (
      portfolio.currentPortfolio &&
      (portfolio.currentPortfolio.onboarded ||
        [
          "forms-generated",
          "forms-submitted",
          "forms-signed",
          "onboarded",
        ].includes(portfolio.currentPortfolio.onboardStatus)) &&
      portfolio.currentPortfolio.uuid &&
      portfolio.currentPortfolio.uuid === currentPortfolioId
    ) {
      this.props.history.push(
        `/Portal/household/${currentHouseholdId}/summary/${portfolio.currentPortfolio.uuid}`
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { portfolio, currentPortfolioId, currentHouseholdId } = this.props;

    if (nextProps.portfolio.currentPortfolio) {
      const managerType = nextProps.portfolio.currentPortfolio.metadata
        .managerType
        ? nextProps.portfolio.currentPortfolio.metadata.managerType
        : this.props.user.user.advisorConfig &&
          this.props.user.user.advisorConfig.managerType !== undefined
        ? this.props.user.user.advisorConfig.managerType
        : this.props.user.advisorConfig.managerType;
      this.setState({
        rror: nextProps.portfolio.currentPortfolio.metadata.cprRror
          ? nextProps.portfolio.currentPortfolio.metadata.cprRror
          : CyMath.roundRROR(
              nextProps.portfolio.currentPortfolio.metadata.rror
            ),
        riskTolerance: nextProps.portfolio.currentPortfolio.metadata.cprRisk
          ? nextProps.portfolio.currentPortfolio.metadata.cprRisk
          : CyMath.roundLossTolerance(
              nextProps.portfolio.currentPortfolio.metadata.risk
            ),
        scenario: nextProps.portfolio.currentPortfolio.metadata.scenario
          ? nextProps.portfolio.currentPortfolio.metadata.scenario
          : "",
        riskAverse:
          nextProps.portfolio.currentPortfolio.metadata.riskAverse !== undefined
            ? nextProps.portfolio.currentPortfolio.metadata.riskAverse
            : this.props.user.user.advisorConfig &&
              this.props.user.user.advisorConfig.riskAverse !== undefined
            ? this.props.user.user.advisorConfig.riskAverse
            : this.props.user.advisorConfig.riskAverse,
        includeTheoretical:
          nextProps.portfolio.currentPortfolio.metadata.includeTheoretical !==
          undefined
            ? nextProps.portfolio.currentPortfolio.metadata.includeTheoretical
            : this.calculateIncludeHypothetical(
                managerType,
                nextProps.portfolio.currentPortfolio.metadata.includeTheoretical
              ),
        managerType,
        riskPeriod: nextProps.portfolio.currentPortfolio.metadata.riskPeriod
          ? nextProps.portfolio.currentPortfolio.metadata.riskPeriod
          : this.props.user.user.advisorConfig &&
            this.props.user.user.advisorConfig.riskPeriod !== undefined
          ? this.props.user.user.advisorConfig.riskPeriod
          : this.props.user.advisorConfig.riskPeriod,
        solveFor: nextProps.portfolio.currentPortfolio.metadata.solveFor
          ? nextProps.portfolio.currentPortfolio.metadata.solveFor
          : "risk",
        singleStrategy:
          nextProps.portfolio.currentPortfolio.metadata.singleStrategy &&
          this.props.singleStrategyList.hasOwnProperty(nextProps.portfolio.currentPortfolio.metadata.managerType) &&
          this.props.singleStrategyList[nextProps.portfolio.currentPortfolio.metadata.managerType].some(
            (ss) =>
              ss.strategyScenario ===
              nextProps.portfolio.currentPortfolio.metadata.singleStrategy
          )
            ? nextProps.portfolio.currentPortfolio.metadata.singleStrategy
            : this.props.singleStrategyList.hasOwnProperty(nextProps.portfolio.currentPortfolio.metadata.managerType) &&
              this.props.singleStrategyList[nextProps.portfolio.currentPortfolio.metadata.managerType].length
            ? this.props.singleStrategyList[nextProps.portfolio.currentPortfolio.metadata.managerType][0].strategyScenario
            : "",
        initialInvestment:
          nextProps.portfolio.currentPortfolio.metadata.initialInvestment,
        portfolioName: nextProps.portfolio.currentPortfolio.name,
        annualWithdrawal:
          nextProps.portfolio.currentPortfolio.metadata.annualWithdrawal || 0,
        portfolioAdvisorFee:
          nextProps.fee.portfolioAdvisorFeeRates[nextProps.currentPortfolioId],
      });
      if (
        nextProps.portfolio.currentPortfolio &&
        (nextProps.portfolio.currentPortfolio.onboarded ||
          [
            "forms-generated",
            "forms-submitted",
            "forms-signed",
            "onboarded",
          ].includes(nextProps.portfolio.currentPortfolio.onboardStatus)) &&
        nextProps.portfolio.currentPortfolio.uuid &&
        nextProps.portfolio.currentPortfolio.uuid === currentPortfolioId
      ) {
        this.props.history.push(
          `/Portal/household/${currentHouseholdId}/summary/${nextProps.portfolio.currentPortfolio.uuid}`
        );
      }

      if (nextProps.portfolio.currentPortfolio.uuid) {
        this.setState({ portfolioFeeUpdateModalOpened: false })
      } else {
        // Disabled this feature for later
        // this.setState({ portfolioFeeUpdateModalOpened: true })
      }
    }

    // if the current portfolio has changed, redirect to the new id
    const oldPortfolioId =
      portfolio &&
      portfolio.currentPortfolio &&
      portfolio.currentPortfolio.uuid;
    if (
      nextProps.portfolio.currentPortfolio &&
      nextProps.portfolio.currentPortfolio.uuid !== currentPortfolioId &&
      nextProps.portfolio.currentPortfolio.uuid !== oldPortfolioId
    ) {
      this.props.history.push(
        `/Portal/household/${this.props.currentHouseholdId}/portfolio/` +
          nextProps.portfolio.currentPortfolio.uuid
      );
    }

    // if incoming portfolio is an onboarded, custom portfolio, then skip to summary
    if (
      !currentHouseholdId &&
      nextProps.portfolio.currentPortfolio &&
      nextProps.portfolio.currentPortfolio.uuid &&
      nextProps.portfolio.currentPortfolio.onboarded
    ) {
      this.props.history.push(
        `/Portal/household/${this.props.currentHouseholdId}/summary/` +
          nextProps.portfolio.currentPortfolio.uuid
      );
    }
  }

  /*
    - If the previous manager type was NOT 'WBI Only', checkbox remains unchanged
    - Check the investment amount and update the dialog / minimum invest amount states
  */
  componentDidUpdate(prevProps, prevState) {
    const { portfolio } = this.props;

    if (prevProps.portfolio.currentPortfolio !== portfolio.currentPortfolio) {
      if (portfolio.currentPortfolio.metadata.initialInvestment < 10000) {
        this.setState({
          minInitInvestDialogOpen: true,
          minInitInvestAmount: "$10,000",
          minInitInvestDialogInstruction:
            "Please edit the investment amount.",
        });
      }
      if (!portfolio.currentPortfolio.cprRecommendation) {
        this.setState({ unsolvableOutcomeDialogOpen: true });
      }
      this.setState({
        initialInvestment:
          portfolio.currentPortfolio.metadata.initialInvestment,
        portfolioName: portfolio.currentPortfolio.name,
      });
    }
  }

  render() {
    const { CurrencyFormatter } = CyNumber;
    const { classes, portfolio, accessLevel, fee } = this.props;
    const {
      unsolvableOutcomeDialogOpen,
      minInitInvestAmount,
      minInitInvestDialogInstruction,
      initialInvestment,
      portfolioName,
      annualWithdrawal,
      portfolioAdvisorFee,
      portfolioAdvisorFeeModalOpened,
      portfolioFeeUpdateModalOpened,
      managerTypeList
    } = this.state;

    if (
      !portfolio ||
      !portfolio.currentPortfolio ||
      !portfolio.currentPortfolio.metadata ||
      portfolio.generatingRecommendation
    ) {
      return <Calculating />;
    }

    const baseChartData = generateChartData(portfolio.currentPortfolio);
    const useWbiSingleStrategy =
      ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType);
    const strategyStartDate = baseChartData && moment(baseChartData[0].date)
      .startOf("month")
      .subtract(2, "months");
    const annualWithdrawalChartData = !!portfolio.currentPortfolio.metadata
      .annualWithdrawal
      ? generateChartData(
          portfolio.currentPortfolio,
          portfolio.currentPortfolio.metadata.annualWithdrawal
        )
      : null;
    const totalWithdrawal = !!portfolio.currentPortfolio.metadata
      .annualWithdrawal
      ? generateChartData(
          portfolio.currentPortfolio,
          portfolio.currentPortfolio.metadata.annualWithdrawal,
          true
        )
      : null;

    const cprRecommendation = portfolio.currentPortfolio.cprRecommendation;
    const benchmarkName = cprRecommendation ? cprRecommendation.summary.benchmark.Name: "";


    return (
      <div className={classes.contentWrapper}>
        <section className={classes.content}>
          <EditableTextField
            staticComponent={
              <SectionHeader
                className={classes.portfolioName}
                text={portfolioName}
              />
            }
            validation={this.validateEditableField()}
            value={portfolioName}
            onSave={this.updatePortfolioName}
            className={classes.portfolioNameEdit}
            name={"portfolioName"}
            isCurrency={false}
          />
          {cprRecommendation &&
            cprRecommendation.displayName && (
              <Typography variant={"subtitle1"}>
                ({cprRecommendation.displayName})
              </Typography>
            )}
          <Typography variant={"body2"} className={classes.subtitle}>
            Client Investment Parameters
          </Typography>
          <Grid container className={classes.paramWrapper}>
            <Parameter label="Market Benchmark">{benchmarkName}</Parameter>
            <Parameter label="Risk Period Selected">{getRiskPeriod(this.state.riskPeriod)}</Parameter>
            <Parameter label="Household RRoR">
              {isBasicView(accessLevel) ? (
                "N/A"
              ):(
                <RRoR rrorValue={portfolio.currentPortfolio.metadata.rror} />
              )}
            </Parameter>
            <Parameter label="Portfolio Annualized Return">
              {cprRecommendation && (
                <PercentageNumber
                  value={
                    cprRecommendation.summary
                      .recommendationSummary.AnnualizedReturn
                  }
                  showSign={true}
                />
              )}
            </Parameter>
            <Parameter label="Household Loss Tolerance">
              {isBasicView(accessLevel) ? (
                "N/A"
              ):(
                <PercentageNumber
                  value={portfolio.currentPortfolio.metadata.risk}
                  showSign={true}
                />
              )}
            </Parameter>
            <Parameter label="Portfolio Loss Tolerance">
              {cprRecommendation && (
                <PercentageNumber
                  value={
                    cprRecommendation.summary
                      .recommendationSummary[
                      getRiskPeriodLossTolerance(
                        portfolio.currentPortfolio.metadata.riskPeriod
                      )
                    ]
                  }
                  showSign={true}
                />
              )}
            </Parameter>
            {
              portfolio.currentPortfolio.PortfolioMarketValue ?
                <Parameter label="Current Market Value">
                  <CurrencyNumber
                      value={
                        portfolio.currentPortfolio.PortfolioMarketValue
                          .marketValue
                      }
                    />
                </Parameter>:
                <Parameter
                  label={
                    <React.Fragment>
                      Investment Amount
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        placement="top-end"
                        disableFocusListener
                        title="Fee based on Investment Amount"
                      >
                        <Button
                          disableRipple
                          disableFocusRipple
                          className={classes.tooltipBtn}
                        >
                          <HelpIcon className={classes.hintIcon} />
                        </Button>
                      </Tooltip>
                    </React.Fragment>
                  }
                >
                  {
                    cprRecommendation &&
                    <EditableTextField
                      validation={this.validateEditableField(
                        cprRecommendation.summary
                          .recommendationSummary.AccountMinimum
                      )}
                      staticComponent={
                        <CurrencyNumber value={initialInvestment} />
                      }
                      onSave={this.updatePortfolio}
                      value={CurrencyFormatter(initialInvestment)}
                      name={"initialInvestment"}
                      isCurrency={true}
                    />
                  }
                </Parameter>
            }

            <Parameter label="Annual Withdrawal">
              {
                portfolio.currentPortfolio.metadata.initialInvestment < 10000 ?
                  <CurrencyNumber value={annualWithdrawal} />:
                  <EditableTextField
                    validation={this.validateEditableField()}
                    staticComponent={
                      <CurrencyNumber value={annualWithdrawal} />
                    }
                    onSave={this.updatePortfolio}
                    value={CurrencyFormatter(annualWithdrawal)}
                    name={"annualWithdrawal"}
                    isCurrency={true}
                  />
              }
            </Parameter>
          </Grid>
          <div className={classes.dInlineBlock}>
            <Typography
              variant={"body2"}
              className={`${classes.contentCaption} ${classes.subtitle}`}
            >
              {useWbiSingleStrategy
                ? cprRecommendation &&
                  cprRecommendation.displayName
                : `Cy Portfolio Output`}{" "}
            </Typography>
            <Typography>
              {baseChartData
                ? moment(baseChartData[0].date)
                    .startOf("month")
                    .subtract(2, "months")
                    .format("MMM YYYY")
                : "Jan 2000"}{" "}
              to {END_OF_CPR_YEAR.format('MMM YYYY')}
            </Typography>
          </div>
          <div className={classes.chartToggleGroup}>
            <div
              className={`${classes.chartSliderControl} ${
                this.state.activeStep === 0 ? "active" : ""
              }`}
              onClick={this.handleToggle(0)}
            >
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title="Table"
                placement={"top"}
                enterDelay={100}
              >
                <TableChartIcon />
              </Tooltip>
            </div>
            <div
              className={`${classes.chartSliderControl} ${
                this.state.activeStep === 1 ? "active" : ""
              }`}
              onClick={this.handleToggle(1)}
            >
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title="Chart"
                placement={"top"}
                enterDelay={100}
              >
                <LineChartIcon />
              </Tooltip>
            </div>
          </div>
          <div className={classes.chartSliderWrapper}>
            {unsolvableOutcomeDialogOpen ? (
              <div className={classes.noPortfolioWrapper} />
            ) : (
              <React.Fragment>
                <SwipeableViews
                  axis={"x"}
                  index={this.state.activeStep}
                  onChangeIndex={this.handleStepChange}
                  onTransitionEnd={this.handleTransitionEnd}
                  disabled
                >
                  <div className={classes.chartWrapper}>
                    {baseChartData &&
                      cprRecommendation &&
                      cprRecommendation.managers && (
                        <CyPortfolioDetailsSortable
                          strategyStartDate={strategyStartDate}
                          managerList={
                            cprRecommendation
                              .managers
                          }
                          portfolioSummary={
                            cprRecommendation.summary
                          }
                          finalWealth={baseChartData.slice(-1)[0]}
                          finalWealthWithAnnualWithdrawal={
                            annualWithdrawalChartData
                              ? annualWithdrawalChartData.slice(-1)[0]
                              : null
                          }
                          riskPeriod={this.state.riskPeriod}
                          totalWithdrawal={totalWithdrawal}
                        />
                      )}
                    {baseChartData &&
                      cprRecommendation && (
                        <CyComparison
                          summaryData={
                            cprRecommendation.summary
                          }
                          finalWealth={baseChartData.slice(-1)[0]}
                          finalWealthWithAnnualWithdrawal={
                            annualWithdrawalChartData
                              ? annualWithdrawalChartData.slice(-1)[0]
                              : null
                          }
                          riskPeriod={this.state.riskPeriod}
                        />
                      )}
                  </div>

                  <div className={classes.chartWrapper}>
                    <Grid container={true}>
                      <Grid item xs={12}>
                        {this.state.activeStep === 1 &&
                          cprRecommendation && (
                            <CyLineChart
                              data={baseChartData}
                              initialInvestment={
                                portfolio.currentPortfolio.metadata
                                  .initialInvestment
                              }
                              showTooltip={!annualWithdrawalChartData}
                              portfolioName={portfolio.currentPortfolio.name}
                              benchmarkName={benchmarkName}
                            />
                          )}
                      </Grid>
                      
                      {this.state.activeStep === 1 &&
                        cprRecommendation &&
                        annualWithdrawalChartData &&
                        portfolio.currentPortfolio.metadata.annualWithdrawal &&
                        portfolio.currentPortfolio.metadata.annualWithdrawal >
                          0 && (
                          <React.Fragment>
                            <Grid item xs={12}>
                              <CyTotalIncomeChart
                                data={totalWithdrawal}
                                initialInvestment={
                                  portfolio.currentPortfolio.metadata
                                    .initialInvestment
                                }
                                annualWithdrawal={
                                  portfolio.currentPortfolio.metadata
                                    .annualWithdrawal
                                }
                                strategyName={
                                  cprRecommendation
                                    .displayName || ""
                                }
                                benchmarkName={benchmarkName}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <CyLineChart
                                data={annualWithdrawalChartData}
                                initialInvestment={
                                  portfolio.currentPortfolio.metadata
                                    .initialInvestment
                                }
                                withAnnualWithdrawal={true}
                                showTooltip={false}
                                portfolioName={portfolio.currentPortfolio.name}
                                benchmarkName={benchmarkName}
                              />
                            </Grid>
                          </React.Fragment>
                        )}
                      <HighLevelDisclosure />

                      {this.state.activeStep === 1 &&
                        cprRecommendation && (
                          <Grid item xs={12}>
                            <CyComparison
                              summaryData={
                                cprRecommendation
                                  .summary
                              }
                              finalWealth={baseChartData.slice(-1)[0]}
                              finalWealthWithAnnualWithdrawal={
                                annualWithdrawalChartData
                                  ? annualWithdrawalChartData.slice(-1)[0]
                                  : null
                              }
                              riskPeriod={this.state.riskPeriod}
                            />
                          </Grid>
                        )}
                      {this.state.activeStep === 1 && (
                        <Grid item xs={12}>
                          <CyMonteCarlo
                            initialInvestment={portfolio.currentPortfolio.metadata.initialInvestment}
                            mean={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedReturn)}
                            sd={parseFloat(cprRecommendation.summary.recommendationSummary.AnnualizedStandardDeviation)}
                            startDate={strategyStartDate}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </SwipeableViews>
              </React.Fragment>
            )}
          </div>
        </section>
        <section>
          <PortfolioFeeUpdateModal
            open={portfolioFeeUpdateModalOpened}
            handleCloseModal={() =>
              this.setState({ portfolioFeeUpdateModalOpened: false })
            }
            initialInvestment={this.state.initialInvestment}
            onSave={this.savePortfolioInvestmentAmount}
            managerType={this.state.managerType}
            strategyMin={
              portfolio.currentPortfolio.cprRecommendation &&
              portfolio.currentPortfolio.cprRecommendation.summary
              .recommendationSummary.AccountMinimum
          }
          />
        </section>
        <section
          className={`${classes.portfolioConfig} ${
            this.state.portfolioConfigDrawerOpened ? "opened" : ""
          }`}
        >
          {
            <Grid container>
              <Grid item xs={11}>
                <Grid
                  container
                  alignItems={"center"}
                  className={classes.portfolioConfigBlockInnerGridContainer}
                >
                  <Grid item xs={3}>
                    <Typography
                      variant="subtitle1"
                      className={classes.settingsText}
                    >
                      Solve For
                    </Typography>
                    <Tooltip
                      classes={{ tooltip: classes.tooltip }}
                      placement="top-start"
                      title={`Solving for Risk allows Cy to maximize portfolio return given an investor’s loss tolerance or risk constraint, but switch to Return if you want Cy to minimize portfolio risk given an investor’s return target`}
                    >
                      <Button
                        disableRipple
                        disableFocusRipple
                        className={classes.tooltipBtn}
                      >
                        <HelpIcon className={classes.hintIcon} />
                      </Button>
                    </Tooltip>
                    {
                      ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType) ? (
                      <RadioGroup
                        className={classes.formGroup}
                        aria-label="Solve For"
                        name="solveFor"
                        value={null}
                      >
                        <FormControlLabel
                          style={{ marginRight: 10 }}
                          value="ret"
                          control={
                            <Radio
                              className={classes.radioBase}
                              color={"primary"}
                              disabled
                            />
                          }
                          label="Return"
                        />
                        <FormControlLabel
                          style={{ marginRight: 10 }}
                          value="risk"
                          control={
                            <Radio
                              className={classes.radioBase}
                              color={"primary"}
                              disabled
                            />
                          }
                          label="Risk"
                        />
                      </RadioGroup>
                    ) : (
                      <RadioGroup
                        className={classes.formGroup}
                        aria-label="Solve For"
                        name="solveFor"
                        value={this.state.solveFor}
                        onChange={(e) =>
                          this.checkMinimumInvest("solveFor", false, e)
                        }
                      >
                        <FormControlLabel
                          style={{ marginRight: 10 }}
                          value="ret"
                          control={
                            <Radio
                              className={classes.radioBase}
                              color={"primary"}
                            />
                          }
                          label="Return"
                        />
                        <FormControlLabel
                          style={{ marginRight: 10 }}
                          value="risk"
                          control={
                            <Radio
                              className={classes.radioBase}
                              color={"primary"}
                            />
                          }
                          label="Risk"
                        />
                      </RadioGroup>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    {this.state.solveFor === "ret" && (
                      <React.Fragment>
                        <Typography
                          variant="h5"
                          className={classes.settingsTextMain}
                        >
                          Target Return
                        </Typography>
                        {
                          ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType) ? (
                          <Select
                            native
                            value={""}
                            inputProps={{ name: "rror" }}
                            className={classes.smallSelect}
                            disabled
                            style={{ minWidth: 80 }}
                          >
                            <option value={""} />
                          </Select>
                        ) : (
                          <Select
                            native
                            value={this.state.rror}
                            onChange={(e) =>
                              this.checkMinimumInvest("rror", false, e)
                            }
                            inputProps={{ name: "rror" }}
                            className={classes.smallSelect}
                          >
                            {this.state.managerType === "401k" ? (
                              <React.Fragment>
                                <option value="0.06">6.00%</option>
                                <option value="0.08">8.00%</option>
                                <option value="0.1">10.00%</option>
                                <option value="0.12">12.00%</option>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <option value="0.05">5.00%</option>
                                <option value="0.06">6.00%</option>
                                <option value="0.07">7.00%</option>
                                <option value="0.08">8.00%</option>
                                <option value="0.09">9.00%</option>
                                <option value="0.1">10.00%</option>
                                <option value="0.11">11.00%</option>
                                <option value="0.12">12.00%</option>
                                <option value="0.13">13.00%</option>
                                <option value="0.14">14.00%</option>
                                <option value="0.15">15.00%</option>
                              </React.Fragment>
                            )}
                          </Select>
                        )}
                      </React.Fragment>
                    )}
                    {this.state.solveFor === "risk" && (
                      <React.Fragment>
                        {/* TODO: change it to classes*/}
                        <Typography
                          variant="h5"
                          className={classes.settingsTextMain}
                        >
                          Loss Tolerance
                        </Typography>
                        <Select
                          native
                          value={this.state.riskTolerance}
                          onChange={(e) =>
                            this.checkMinimumInvest("riskTolerance", false, e)
                          }
                          inputProps={{
                            name: "riskTolerance",
                          }}
                          className={classes.smallSelect}
                          disabled={
                            ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(this.state.managerType)
                          }
                        >
                          <option value="-0.05">-5.00%</option>
                          <option value="-0.1">-10.00%</option>
                          <option value="-0.15">-15.00%</option>
                          <option value="-0.2">-20.00%</option>
                          {this.state.managerType !== "401k" && (
                            <option value="-0.25">-25.00%</option>
                          )}
                          <option value="-0.3">-30.00%</option>
                          {this.state.managerType !== "401k" && (
                            <option value="-0.35">-35.00%</option>
                          )}
                          <option value="-0.4">-40.00%</option>
                        </Select>
                      </React.Fragment>
                    )}
                  </Grid>

                  <Grid item xs={3}>
                    <Typography
                      variant="subtitle1"
                      className={classes.settingsText}
                    >
                      Strategy Type
                    </Typography>
                    <Tooltip
                      classes={{ tooltip: classes.tooltip }}
                      placement="top-end"
                      disableFocusListener
                      title={`Select the type of manager strategies to be used by Cy.`}
                    >
                      <Button
                        disableRipple
                        disableFocusRipple
                        className={classes.tooltipBtn}
                      >
                        <HelpIcon className={classes.hintIcon} />
                      </Button>
                    </Tooltip>
                    <br />
                    <Select
                      native
                      className={classes.smallSelect}
                      value={this.state.managerType}
                      onChange={(e) =>
                        this.checkMinimumInvest("managerType", false, e)
                      }
                      inputProps={{
                        name: "managerType",
                      }}
                    >
                      {
                        managerTypeList.map((m) => (<option key={m.code} value={m.code}>{m.name}</option>))
                      }
                    </Select>
                  </Grid>
                  <Grid item xs={3}>
                    {/*Risk Selection*/}
                    <Typography
                      variant="subtitle1"
                      className={classes.settingsText}
                    >
                      Risk Selection
                    </Typography>
                    <Tooltip
                      classes={{ tooltip: classes.tooltip }}
                      placement="top-end"
                      disableFocusListener
                      title={`Select the type of risk period used when Cy is evaluating an investor’s loss tolerance`}
                    >
                      <Button className={classes.tooltipBtn}>
                        <HelpIcon className={classes.hintIcon} />
                      </Button>
                    </Tooltip>
                    <br />
                    <Select
                      native
                      className={classes.smallSelect}
                      value={this.state.riskPeriod}
                      onChange={(e) =>
                        this.checkMinimumInvest("riskPeriod", false, e)
                      }
                      inputProps={{
                        name: "riskPeriod",
                      }}
                      disabled={this.state.managerType === "401k"}
                    >
                      <option value="mdd">Worst Drawdown</option>
                      <option value="worst.calendar.year">
                        Worst Calendar Year
                      </option>
                      <option value="worst.4q">Worst Four Quarters</option>
                    </Select>
                  </Grid>
                </Grid>
                <Grid
                  container
                  alignItems={"center"}
                  className={classes.portfolioConfigBlockInnerGridContainer}
                >
                  <Grid item xs={3} />
                  {Object.keys(this.props.singleStrategyList).includes(this.state.managerType) ? (
                    <Grid item xs={6}>
                      {/*Portfolio*/}
                      <Typography
                        variant="subtitle1"
                        className={classes.settingsText}
                      >
                        Portfolio
                      </Typography>
                      <br />
                      <Select
                        native
                        className={classes.smallSelect}
                        value={this.state.singleStrategy}
                        onChange={(e) =>
                          this.checkMinimumInvest("singleStrategy", false, e)
                        }
                        inputProps={{
                          name: "singleStrategy",
                        }}
                      >
                        {
                          this.props.singleStrategyList[this.state.managerType] &&
                          this.props.singleStrategyList[this.state.managerType].map((s) => (
                          <option
                            value={s.strategyScenario}
                            key={s.strategyScenario}
                          >
                            {s.strategyName}
                          </option>
                        ))}
                      </Select>
                    </Grid>
                  ) : (
                    <React.Fragment>
                      <Grid item xs={3} />
                      {!isBasicView(accessLevel) && (
                        <React.Fragment>
                          <Grid item xs={3}>
                            <div className={`${classes.includeCheckbox}`}>
                              {/*Include Back-Tested*/}
                              <Typography
                                variant="subtitle1"
                                className={classes.settingsText}
                              >
                                Back-Tested
                              </Typography>
                              <Tooltip
                                classes={{ tooltip: classes.tooltip }}
                                placement="top-end"
                                disableFocusListener
                                title={`Check to have Cy include WBI strategies where the historical return series includes back-tested models.`}
                              >
                                <Button
                                  disableRipple
                                  disableFocusRipple
                                  className={classes.tooltipBtn}
                                >
                                  <HelpIcon className={classes.hintIcon} />
                                </Button>
                              </Tooltip>
                              <br />
                              <label>
                                <Checkbox
                                  className={classes.checkbox}
                                  checked={this.state.includeTheoretical}
                                  onChange={(e) =>
                                    this.checkMinimumInvest(
                                      "includeTheoretical",
                                      true,
                                      e
                                    )
                                  }
                                  color="primary"
                                  disabled={!!managerTypeList.filter(m => m.allowBackTested === false).find(m => m.code === this.state.managerType)}
                                />
                                <Typography
                                  variant="subtitle1"
                                  className={classes.settingsText}
                                >
                                  Include
                                </Typography>
                              </label>
                            </div>
                          </Grid>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}

                  {!isBasicView(accessLevel) && (
                    <Grid item xs={3}>
                      <Typography
                        variant="subtitle1"
                        className={classes.settingsText}
                      >
                        AF
                      </Typography>
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        placement="top-end"
                        disableFocusListener
                        title={`Adjust Advisor Fee here which will affect the Fee Summary that follows. Please note that all performance returns shown do not include the Advisor Fee or any other fees associated with the Cy platform.`}
                      >
                        <Button
                          disableRipple
                          disableFocusRipple
                          className={classes.tooltipBtn}
                        >
                          <HelpIcon className={classes.hintIcon} />
                        </Button>
                      </Tooltip>
                      <br />
                      <Select
                        native
                        className={classes.smallSelect}
                        value={
                          getValidAdvisorFees(
                            portfolioAdvisorFee,
                            fee.advisorFeeRate,
                            fee.advisorDefaultFeeRate
                          )
                        }
                        onChange={() =>
                          this.setState({ portfolioAdvisorFeeModalOpened: true })
                        }
                        inputProps={{ name: "AF" }}
                      >
                        <option value={-1}>Custom...</option>
                        <option
                          value={
                            getValidAdvisorFees(
                              portfolioAdvisorFee,
                              fee.advisorFeeRate,
                              fee.advisorDefaultFeeRate
                            )
                          }
                        >
                          {
                            getValidAdvisorFees(
                              portfolioAdvisorFee,
                              fee.advisorFeeRate,
                              fee.advisorDefaultFeeRate
                            )
                          }
                        </option>
                      </Select>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                xs={1}
                style={{
                  borderLeft: `1px solid ${this.props.theme.palette.secondary.lightGray}`,
                }}
              >
                <span
                  className={classes.settingDrawerControl}
                  onClick={() => {
                    this.setState({
                      portfolioConfigDrawerOpened:
                        !this.state.portfolioConfigDrawerOpened,
                    });
                  }}
                >
                  {!this.state.portfolioConfigDrawerOpened ? (
                    <React.Fragment>
                      <SettingsIcon fontSize="default" color={"action"} />
                      <Typography>More Settings</Typography>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CloseIcon fontSize="default" color={"action"} />
                      <Typography>Close</Typography>
                    </React.Fragment>
                  )}
                </span>
              </Grid>
            </Grid>
          }
        </section>
        <section
          className={classNames(
            classes.controller,
            portfolio.cprDataError && classes.controllerDisabled
          )}
        >
          <button
            className={classes.saveButtonNavItem}
            onClick={this.directToSummary.bind(this)}
            disabled={portfolio.cprDataError}
          >
            Save
            <DoubleArrowRight />
          </button>
        </section>
        <Dialog
          open={this.state.unsolvableOutcomeDialogOpen}
          TransitionComponent={Transition}
          onClose={this.unsolvableOutcomeDialogClose}
          aria-labelledby="unsolvable-outcome-dialog"
          aria-describedby="unsolvable-outcome-dialog-description"
        >
          <DialogTitle id="unsolvable-outcome-dialog-title">
            Unsolvable Outcome Generated
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="unsolvable-outcome-dialog-description">
              No suggestions available for your selections.
            </DialogContentText>
            <DialogContentText id="unsolvable-outcome-dialog-description">
              The suggestions will now default to your previous selections.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.unsolvableOutcomeDialogClose}>OK</Button>
          </DialogActions>
        </Dialog>

        <PortfolioAdvisorFeeModal
          open={portfolioAdvisorFeeModalOpened}
          handleCloseModal={() =>
            this.setState({ portfolioAdvisorFeeModalOpened: false })
          }
          portfolioAdvisorFee={Number(
            portfolioAdvisorFee ||
              fee.advisorFeeRate ||
              fee.advisorDefaultFeeRate
          )}
          baseAdvisorFee={Number(
            fee.advisorFeeRate || fee.advisorDefaultFeeRate
          )}
          savePortfolioAdvisorFee={this.savePortfolioAdvisorFee}
        />

        <MinimumRequiredDialog
          open={this.state.minInitInvestDialogOpen}
          onClose={this.minInitInvestDialogClose}
          minAmount={minInitInvestAmount}
          message={minInitInvestDialogInstruction}
        />
      </div>
    );
  }
}

Portfolio.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  portfolio: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let portfolioId = ownProps.match.params.portfolioId;
  let householdId = ownProps.match.params.householdId;
  return {
    currentPortfolioId: portfolioId,
    currentHouseholdId: householdId,
    user: state.user,
    accessLevel: state.user.user.userRole.accessLevel,
    portfolio: state.portfolio,
    singleStrategyList: state.portfolio.singleStrategyList,
    strategyAccountMinimum: state.portfolio.strategyAccountMinimum,
    fee: state.fee,
    appName: state.app.appName
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Portfolio)
);



// WEBPACK FOOTER //
// ./src/containers/Portfolio/index.jsx